import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { VarParamI } from '../modelos/VariableParametrica';
import { ApiService } from '../servicios/api/api.service';
import { AppServiceService } from '../servicios/AppService.service';

@Component({
  selector: 'app-parametricas',
  templateUrl: './parametricas.component.html',
  styleUrls: ['./parametricas.component.css']
})
export class ParametricasComponent implements OnInit {

  

  varParametricas : VarParamI[];
  page : number;

  nuevaVariPara : VarParamI;

  @ViewChild('closeModalnuevaVariable') closeModalnuevaVariable: ElementRef;

  constructor(
    private api:ApiService,
    private router:Router,
    private appService:AppServiceService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.nuevaVariPara = new VarParamI;

    this.api.getVariableParametricaChv().subscribe(data=>{
      this.varParametricas = data;
      //console.log(this.varParametricas);
    });
  }

  crearNuevaVariableParametrica(){
    /*console.log(this.nuevaVariPara);
    if (this.nuevaVariPara.nombre == "" ){
      this.toastr.warning('Nombre requerido.', 'Advertencia!'); 
    } /*else if (this.nuevaVariPara.descrip == "" ){
      this.toastr.warning('Descripción requerida.', 'Advertencia!'); 
    } else {
      this.api.nuevaVariableParametrica(this.nuevaVariPara).subscribe(result=>{
        if(result){
          this.closeModalnuevaVariable.nativeElement.click();
          this.toastr.success('Parametrica creada.', 'OK!');
          this.ngOnInit();
        }
      }, error=>{
        this.toastr.error('La parametrica no fue creada.', 'Error!');
      });
       
    }*/
  }

  goContenidoVariable(id){
    this.router.navigate(['variable', id]);
  }

  ParametricasChv(){
    this.router.navigate(['parametricaschv']);
  }

  ParametricasFivi(){
    this.router.navigate(['parametricasfivi']);
  }


}
